import { createFileRoute } from '@tanstack/react-router';
import { GroupPage } from '../../features/B2a/group-page';

/** #/group/<id> — one WhatsApp group: details, participants, settings, invite link, join requests, assignment, leave. Lane B2a. */
export const Route = createFileRoute('/_app/group/$groupId')({
  component: Group,
});

function Group() {
  const { groupId } = Route.useParams();
  return <GroupPage key={groupId} groupId={groupId} />;
}
